import { createContext } from 'react';
import { AliceApp } from '../model/skill';
import { Operation, OperationType } from '../model/operation';

export interface CurrentAliceAppContextParams {
    aliceApp: AliceApp;
    operations: Operation[];
    addOperation: (o: Operation) => void;
    lastOperationType?: OperationType;
    lastOperationComment?: string;
    fetchOperations: () => void;
}

const CurrentAliceAppContext = createContext<CurrentAliceAppContextParams | null>(null);

export { CurrentAliceAppContext };
